// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FunnelPlotOutlinedSvg from "@fishx/icons-svg/es/asn/FunnelPlotOutlined";
import FishxIcon from '../components/FishxIcon';

var FunnelPlotOutlined = function FunnelPlotOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotOutlinedSvg
  }));
};

FunnelPlotOutlined.displayName = 'FunnelPlotOutlined';
export default React.forwardRef(FunnelPlotOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FunnelPlotOutlined.js
// module id = 2860
// module chunks = 0